import React from 'react';
import styled from 'styled-components';
import dn from '../../assets/dn.png';
import Arcticicemin from '../../components/Arcticicemin/Arcticicemin';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;

class CardArcticicemin extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Arcticicemin/>

    </Viz>

   <ReusableDetailCard
   trend= {dn}
   metricsm="12.85% per decade"
   diagnosis="Arctic sea ice, measured each September, is now declining at a rate of 12.85 percent per decade, relative to the 1981 to 2010 average."
   prediction="Reduced polar ice  will accelerate global temperature rise, as newly exposed dark waters absorb more solar energy."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardArcticicemin;
